angular
    .module('lingoda.Teacher/onboarding_step2', [])
    .controller('ApplicationController', [
        '$scope',
        '$timeout',
        function ($scope, $timeout) {
            $scope.certificates = [];
            $scope.cv = {
                name: '',
            };
            $scope.experienceRequired = true;
            $scope.motivationDetailsRequired = true;

            $scope.uploadCv = function (event) {
                const file = event.target.files[0];
                const maxFileSize = 5 * 1024 * 1024; // 5MB
                const acceptableMimeTypes = [
                    'application/pdf',
                    'application/x-pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                ];

                if (!acceptableMimeTypes.includes(file.type) || file.size > maxFileSize) {
                    return;
                }

                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    $scope.cv.name = file.name;
                    $scope.teacher_registration.experience.teacherInfo.newCv.binaryContent =
                        reader.result;
                    $scope.$applyAsync();
                };
            };

            $scope.removeCv = function (event) {
                $scope.cv.name = '';
                $scope.teacher_registration.experience.teacherInfo.newCv.binaryContent = '';
            };

            $scope.uploadCertificate = function (event) {
                const file = event.target.files[0];
                const maxFileSize = 4 * 1024 * 1024; // 4MB
                const acceptableMimeTypes = [
                    'application/pdf',
                    'application/x-pdf',
                    'image/jpeg',
                    'image/png',
                ];

                if (!acceptableMimeTypes.includes(file.type) || file.size > maxFileSize) {
                    return;
                }

                if ($scope.certificates.length >= 6) {
                    $scope.$emit('mainMessages:add', {
                        type: 'error',
                        content: 'You can only upload up to 6 certificates',
                    });
                    $scope.$applyAsync();
                    return;
                }

                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    if (
                        angular.equals(
                            $scope.teacher_registration.personal.teacherInfo.teacherCertificates,
                            {},
                        )
                    ) {
                        $scope.teacher_registration.personal.teacherInfo.teacherCertificates = [];
                    }

                    $scope.$apply(function () {
                        $scope.teacher_registration.personal.teacherInfo.teacherCertificates.push({
                            newFile: { binaryContent: reader.result },
                        });
                        $scope.certificates.push({ name: file.name });
                    });
                };
            };

            $scope.removeCertificate = function (index) {
                $scope.certificates.splice(index, 1);
                $scope.teacher_registration.personal.teacherInfo.teacherCertificates.splice(
                    index,
                    1,
                );
            };

            $scope.setReviewApplication = function (v) {
                if (v) {
                    $scope.$broadcast('ling:form:refreshFields');
                }
                $scope.reviewApplication = v;
            };

            $scope.sectionChanged = function () {
                $timeout(function () {
                    $scope.$broadcast('resposelect:list:build');
                });
            };

            $scope.$watch('teacher_registration.personal.section', function (newValue) {
                $scope.experienceRequired = newValue !== '2';
                $scope.motivationDetailsRequired = newValue !== '2';
            });

            $scope.$watch('teacher_registration.personal.email', function (newValue) {
                $scope.email = newValue;
            });

            $scope.openConfirmationModal = function () {
                $scope.closeCheckModal();
                $('#confirmation-modal').modal('show');
            };

            $scope.closeConfirmationModal = function () {
                $('#confirmation-modal').modal('hide');
                $scope.setReviewApplication(false);
            };

            $scope.openCheckModal = function () {
                $('#check-modal').modal('show');
            };

            $scope.closeCheckModal = function () {
                $('#check-modal').modal('hide');
            };

            $scope.openSendModal = function () {
                $('#send-modal').modal('show');
            };

            $scope.closeSendModal = function () {
                $('#send-modal').modal('hide');
            };

            $scope.submitApplication = function () {
                $('#confirmation-modal').modal('hide');
                $scope.openSendModal();
            };

            $scope.scrollToInvalid = function () {
                const firstInvalid = document.querySelector(
                    '.ng-invalid:first-of-type:not(.ling-form)',
                );

                if (firstInvalid) {
                    $timeout(() => {
                        firstInvalid.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    }, 0);
                }
            };

            $scope.$on('ling:form:request:start', function () {
                if (!$scope.reviewApplication) {
                    $scope.openCheckModal();
                }
            });

            $scope.$on('ling:form:response:fail', function () {
                $scope.closeCheckModal();
                $scope.closeSendModal();
                $scope.closeConfirmationModal();
            });

            $scope.$on('ling:form:validate', function () {
                $scope.scrollToInvalid();
            });
        },
    ])
    .controller('ApplicationItemController', [
        '$scope',
        '$timeout',
        function ($scope, $timeout) {
            $scope.$on('ling:form:response:done', function (e, result) {
                $timeout(function () {
                    var validForm = true;
                    angular.forEach(lingoda.ENV.applicationForms, function (v) {
                        if (!result.data.sections[v]) {
                            validForm = false;
                            $scope.scrollToInvalid();
                            return false;
                        }
                    });

                    if (validForm) {
                        $scope.setReviewApplication(true);
                        $scope.openConfirmationModal();
                    } else {
                        $scope.setReviewApplication(false);
                        $scope.closeCheckModal();
                        $scope.closeSendModal();
                    }
                }, 1000);
            });
        },
    ])
    .controller('CertificateUploadController', [
        '$scope',
        function ($scope) {
            $scope.fileUploadOptions = {
                acceptFileTypes: /(\.|\/)(pdf|jpe?g|png)$/i,
                maxFileSize: 4 * 1024 * 1024,
            };
        },
    ])
    .controller('CvUploadController', [
        '$scope',
        function ($scope) {
            $scope.fileUploadOptions = {
                acceptFileTypes: /(\.|\/)(pdf|doc|docx)$/i,
                maxFileSize: 5 * 1024 * 1024,
            };
        },
    ]);
